import { Box, Flex, Text } from '@chakra-ui/react';

import { ContactMessageEntry } from '../../../../../../services/marketplace/generated/kubb/models/ContactMessageEntry';
import { formatMessageTime } from '../../../../../../utils/dates';
import { PLATFORM_LABEL } from './utils';

type MessageBubbleProps = {
  message: ContactMessageEntry;
  won?: boolean;
};

const BUBBLE_STYLE: Record<
  ContactMessageEntry['senderRole'],
  { bg: string; color: string; borderWidth?: string; borderColor?: string }
> = {
  driver: { bg: 'leaseEndBlue', color: 'white' },
  dealer: { bg: 'iceBlue', color: 'leaseEndBlue' },
  platform: { bg: 'white', color: 'grayDark', borderWidth: '1px', borderColor: 'mistBlue' },
};

const senderLabel = (message: ContactMessageEntry, won?: boolean): string | undefined => {
  if (message.senderRole === 'platform') return PLATFORM_LABEL;
  if (message.senderRole !== 'dealer') return undefined;
  if (won) return message.senderName ?? message.orgName ?? undefined;
  return `Buyer ${message.orgName}`;
};

const MessageBubble = ({ message, won }: MessageBubbleProps) => {
  const isDriver = message.senderRole === 'driver';
  const label = senderLabel(message, won);

  return (
    <Flex direction="column" align={isDriver ? 'flex-end' : 'flex-start'}>
      {label != null && (
        <Text
          mb="3px"
          fontSize="10.5px"
          fontWeight="700"
          letterSpacing="0.04em"
          color="leaseEndBlue"
        >
          {label}
        </Text>
      )}
      <Box
        maxW="80%"
        px="14px"
        py="9px"
        borderRadius="14px"
        fontSize="14px"
        lineHeight="1.4"
        whiteSpace="pre-wrap"
        wordBreak="break-word"
        {...BUBBLE_STYLE[message.senderRole]}
      >
        {message.body}
      </Box>
      <Text mt="3px" fontSize="10.5px" color="grayMedium">
        {formatMessageTime(message.createdAt)}
      </Text>
    </Flex>
  );
};

export default MessageBubble;
